import QualsPage from './QualsPage';

export default { QualsPage };
